// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionD_TheComp__55krm","TheComp2":"SectionD_TheComp2__bUCtA"};